<ol>
 
  <li>
    <button matButton="elevated" (click)="openDialog()">ADD CLIENT</button>
  </li>
  @if (animal()) {
    <li>
      You chose: <em>{{animal()}}</em>
    </li>
  }
</ol>

